
export const MOODS = [
  { value: 'joyeux', label: 'Joyeux', color: 'text-green-500' },
  { value: 'énergique', label: 'Énergique', color: 'text-yellow-500' },
  { value: 'neutre', label: 'Neutre', color: 'text-blue-500' },
  { value: 'léthargique', label: 'Léthargique', color: 'text-purple-500' },
  { value: 'triste', label: 'Triste', color: 'text-red-500' },
];

export const APPETITE_LEVELS = [
  { value: 'excellent', label: 'Excellent' },
  { value: 'normal', label: 'Normal' },
  { value: 'faible', label: 'Faible' },
  { value: 'aucun', label: 'Aucun' },
];

export { STOOL_SCORES, STOOL_COLORS } from '../shared/constants/stoolConstants';

export const SYMPTOMS_LIST = [
  'Vomissements', 'Diarrhée', 'Toux', 'Boiterie', 'Démangeaisons', 'Perte d\'appétit', 'Soif excessive', 'Léthargie'
];

export const REMINDER_TYPES = [
  { value: 'veterinaire', label: 'Rendez-vous Vétérinaire' },
  { value: 'controle', label: 'Contrôle annuel' },
  { value: 'vaccin', label: 'Vaccins' },
];